<ng-container *ngIf="groups?.length; then groupsTemplate; else emptyTemplate"></ng-container>
<ng-template #groupsTemplate>

    <accordion [multi]="true">

        <accordion-group [title]="group?.title ?? 'No Group'" [showTitleLine]="true" [expanded]="true" *ngFor="let group of groups">
            <!-- <w-button displayStyle="Primary" iconLeft="fa-regular fa-plus" label="Add files" actions (onClick)="addFile.emit(entity); $event?.stopPropagation()" *ngIf="group?.type === entity" /> -->
            <attachments (itemUpdated)="onItemUpdated($event)" [entity]="entity" [selectOnClick]="context?.displayMode === 'Picker'" [expandable]="context?.displayMode === 'Picker'" [attachments]="$safeNavigationMigration(group?.attachments)" [gridColumns]="context?.displayMode === 'Sidebar' ? 2 : -1" [selectable]="true" [timezone]="$safeNavigationMigration(context?.timezone)" [showMetadata]="true" [registerWithKeyManager]="true" [showTags]="group?.type === entity || !group?.hideTags" [deletable]="false" (itemExpand)="itemExpand.emit($event)" />
        </accordion-group>

    </accordion>

</ng-template>
<ng-template #emptyTemplate>
    <empty-message [message]="'No files were found.'" [icon]="'fa-regular fa-files'"></empty-message>
</ng-template>